import { AxiosResponse } from 'axios';

import { ResponseError } from 'store/railsBuilder/reducer.types';

function isErrorResponse(
    response: any,
): response is AxiosResponse<ResponseError> {
    return !!response?.data?.error;
}

export default isErrorResponse;
